import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

/**
 * Controle que mostra o nível de zoom atual do mapa (ex.: "Z: 6").
 * É adicionado em leaflet-top leaflet-left, idealmente entre o zoom control e o reset button.
 */
const ZoomLevelControl = () => {
  const map = useMap();

  useEffect(() => {
    let labelEl = null;

    const ZoomCtrl = L.Control.extend({
      options: { position: 'topleft' },
      onAdd: function () {
        const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control zoom-level-control');
        container.style.display = 'flex';
        container.style.alignItems = 'center';
        container.style.justifyContent = 'center';
        container.style.padding = '0 6px';
        container.style.fontSize = '12px';
        container.style.fontWeight = '600';
        container.style.background = 'white';
        container.style.borderRadius = '4px';
        container.style.userSelect = 'none';
        container.style.cursor = 'default';
        container.title = 'Nível de zoom atual';

        labelEl = L.DomUtil.create('span', '', container);
        const z = map.getZoom();
        labelEl.textContent = `Z: ${z}`;

        // Não interceptar scroll do mouse enquanto sobre o controle
        L.DomEvent.disableClickPropagation(container);
        L.DomEvent.disableScrollPropagation(container);
        return container;
      },
    });

    const control = new ZoomCtrl();
    map.addControl(control);

    const update = () => {
      try {
        if (labelEl) labelEl.textContent = `Z: ${map.getZoom()}`;
      } catch (_) {
        /* no-op */
      }
    };

    map.on('zoomend', update);

    return () => {
      try {
        map.off('zoomend', update);
      } catch (_) {
        /* no-op */
      }
      try {
        map.removeControl(control);
      } catch (_) {
        /* no-op */
      }
    };
  }, [map]);

  return null;
};

export default ZoomLevelControl;
